<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script type="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue { }
</script>

<style></style>
